import angular from 'angular';

(function () {
    'use strict';
    angular.module('app.core').factory('Beneficiairy', BeneficiairyData);

    BeneficiairyData.$inject = [];

    /* @ngInject */
    function BeneficiairyData() {
        Beneficiairy.prototype = {
            build: build,
            getBeneficiaryName: getBeneficiaryName,
        };

        function Beneficiairy(beneficiairyData) {
            if (beneficiairyData) {
                this.build(beneficiairyData);
            }
        }

        return Beneficiairy;

        /////////////////////

        function build(beneficiaryData) {
            this.sellerId = beneficiaryData.sellerId || null;
            this.name = beneficiaryData.name || null;
            this.idFiscal = beneficiaryData.idFiscal || null;
            this.idNational = beneficiaryData.idNational || null;
        }

        function getBeneficiaryName() {
            var name = this.name;
            if (this.idFiscal) {
                name += ' (' + this.idFiscal + ')';
            } else if (this.idNational) {
                name += ' (' + this.idNational + ')';
            }
            return name;
        }
    }
})();
